<form class="form-search-bar" [formGroup]="currencyForm" autocomplete="off">
  <div style="display: flex">
    <mat-form-field appearance="outline" fxFlex="50">
      <mat-label>Choose the currency</mat-label>
      <mat-select [formControl]="currencyControl" (change)="equivalenceControl.reset(); sourceControl.reset()">
        <mat-option *ngFor="let currency of currencies" [value]="currency.name">{{currency.name}} ({{currency.symbol}})</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" [class]="currencyControl.value === 'Euro' ? 'display-none' : ''">
      <mat-label>1 {{currencyControl.value}} equals to ? euro(s)</mat-label>
      <input matInput type="number" [formControl]="equivalenceControl"  (change)="hideAllExpanded()">
    </mat-form-field>
  </div>
  <mat-form-field appearance="outline" [class]="currencyControl.value === 'Euro' ? 'display-none' : ''">
    <mat-label>Exchange source justification</mat-label>
    <textarea matInput [formControl]="sourceControl"></textarea>
  </mat-form-field>
</form>

<form class="form-search-bar form-table" [formGroup]="entriesForm" (ngSubmit)="entriesSubmit()" autocomplete="off">
  <div class="info">
    <h1>Operations</h1>
    <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Cost.Operations'"></app-help-icon-button>
  </div>
  <table class="kf-registration-table-cost-operations" mat-table [dataSource]="categories" formArrayName="entries" [multiTemplateDataRows]="true">

    <ng-container matColumnDef="entry">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let category; let i = dataIndex">
        <div class="entity-elements">
          <div>
            <mat-icon [class]="currencyControl.value === 'Euro' || (currencyControl.value !== 'Euro' && (equivalenceControl.value === 0 || equivalenceControl.value === null)) ? 'visibility-hidden' : ''"
                      (click)="expandedElement = expandedElement === category ? null : category; changeIcon(i, icon);">{{icon[i]?.icon}}
            </mat-icon>
            <p>{{category.description}}</p>
          </div>
          <span>Total</span>
        </div>
      </td>
      <td mat-footer-cell *matFooterCellDef> Total Operations </td>
    </ng-container>

    <ng-container matColumnDef="collection">
      <th mat-header-cell *matHeaderCellDef>
        <div class="info">
          Collection
          <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Cost.Operations.Collection'"></app-help-icon-button>
        </div>
      </th>
      <td mat-cell *matCellDef="let category; let i = dataIndex" [formGroupName]="i">
        <mat-form-field appearance="outline" class="filter-item">
          <input onfocus="this.select()" class="input-number" matInput type="number" formControlName="collection"
                 [readonly]="kfRegistrationDetail?.kfRegistration?.completionStatus"
                 (change)="sum()"
                 [mdePopoverTriggerFor]="collectionPopover"
                 mdePopoverTriggerOn="none"
                 mdePopoverArrowColor="none"
                 (click)="entriesControl.at(i).get('collection')?.invalid ? popoverTrigger.openPopover() : null"
                 #popoverTrigger="mdePopoverTrigger"
          />
          <mde-popover #collectionPopover="mdePopover" [mdePopoverOverlapTrigger]="false" [class]="entriesControl.at(i)?.get('collection')?.hasError('max') || entriesControl.at(i)?.get('collection')?.hasError('min') ? '' : 'visibility-hidden'">
            <mat-card *ngIf="entriesControl.at(i)?.get('collection')?.hasError('max') || entriesControl.at(i)?.get('collection')?.hasError('min')">
              <mat-card-content>
                <p *ngIf="entriesControl.at(i)?.get('collection')?.hasError('max')">
                  {{entriesControl.at(i)?.get('collection')?.value > 0 ?
                  'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% higher than last year figure. Click to mark as correct'
                  : 'Negative cost indicated, if this was in fact a revenue click "Allow" to continue otherwise please correct the data'}}
                </p>
                <p *ngIf="entriesControl.at(i)?.get('collection')?.hasError('min')">
                  {{entriesControl.at(i)?.get('collection')?.value > 0 ?
                  'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% lower than last year figure. Click to mark as correct'
                  :'Negative cost indicated, if this was in fact a revenue click "Allow" to continue otherwise please correct the data'}}
                </p>
              </mat-card-content>
              <mat-card-actions align="end">
                <button mat-raised-button type="button"  (click)="collectionPopover._emitCloseEvent()">Close</button>
                <button mat-raised-button type="button" color="primary" (click)="allowValidation('collection', i)">Allow</button>
              </mat-card-actions>
            </mat-card>
          </mde-popover>
        </mat-form-field>
      </td>
      <td mat-footer-cell *matFooterCellDef>
        <mat-form-field appearance="outline" class="filter-item">
          <input class="input-number" matInput type="number" [readonly]="true" [value]="totalValues[0].toFixed(2)"/>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="logistics">
      <th mat-header-cell *matHeaderCellDef>
        <div class="info">
          Logistics
          <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Cost.Operations.Logistics'"></app-help-icon-button>
        </div>
      </th>
      <td mat-cell *matCellDef="let category; let i = dataIndex" [formGroupName]="i">
        <mat-form-field appearance="outline" class="filter-item">
          <input onfocus="this.select()" class="input-number" matInput type="number" formControlName="logistics"
                 [readonly]="kfRegistrationDetail?.kfRegistration?.completionStatus"
                 (change)="sum()"
                 [mdePopoverTriggerFor]="logisticsPopover"
                 mdePopoverTriggerOn="none"
                 mdePopoverArrowColor="none"
                 (focusin)="entriesControl.at(i).get('logistics')?.invalid ? popoverTrigger.openPopover() : null"
                 #popoverTrigger="mdePopoverTrigger"
          />
          <mde-popover #logisticsPopover="mdePopover" [mdePopoverOverlapTrigger]="false">
            <mat-card *ngIf="entriesControl.at(i)?.get('logistics')?.hasError('max') || entriesControl.at(i)?.get('logistics')?.hasError('min')">
              <mat-card-content>
                <p *ngIf="entriesControl.at(i)?.get('logistics')?.hasError('max')">
                  {{entriesControl.at(i)?.get('logistics')?.value > 0 ?
                  'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% higher than last year figure. Click to mark as correct'
                  : 'Negative cost indicated, if this was in fact a revenue click "Allow" to continue otherwise please correct the data'}}
                </p>
                <p *ngIf="entriesControl.at(i)?.get('logistics')?.hasError('min')">
                  {{entriesControl.at(i)?.get('logistics')?.value > 0 ?
                  'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% lower than last year figure. Click to mark as correct'
                  :'Negative cost indicated, if this was in fact a revenue click "Allow" to continue otherwise please correct the data'}}
                </p>
              </mat-card-content>
              <mat-card-actions align="end">
                <button mat-raised-button type="button" (click)="logisticsPopover._emitCloseEvent()">Close</button>
                <button mat-raised-button type="button" color="primary" (click)="allowValidation('logistics', i)">Allow</button>
              </mat-card-actions>
            </mat-card>
          </mde-popover>
        </mat-form-field>
      </td>
      <td mat-footer-cell *matFooterCellDef>
        <mat-form-field appearance="outline" class="filter-item">
          <input class="input-number" matInput type="number" [readonly]="true" [value]="totalValues[1].toFixed(2)"/>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="treatment">
      <th mat-header-cell *matHeaderCellDef>
        <div class="info">
          Treatment
          <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Cost.Operations.Treatment'"></app-help-icon-button>
        </div>
      </th>
      <td mat-cell *matCellDef="let category; let i = dataIndex" [formGroupName]="i">
        <mat-form-field appearance="outline" class="filter-item">
          <input onfocus="this.select()" class="input-number" matInput type="number" formControlName="treatment"
                 [readonly]="kfRegistrationDetail?.kfRegistration?.completionStatus"
                 (change)="sum()"
                 [mdePopoverTriggerFor]="treatmentPopover"
                 mdePopoverTriggerOn="none"
                 mdePopoverArrowColor="none"
                 (focusin)="entriesControl.at(i).get('treatment')?.invalid ? popoverTrigger.openPopover() : null"
                 #popoverTrigger="mdePopoverTrigger"
          />
          <mde-popover #treatmentPopover="mdePopover" [mdePopoverOverlapTrigger]="false">
            <mat-card *ngIf="entriesControl.at(i)?.get('treatment')?.hasError('max') || entriesControl.at(i)?.get('treatment')?.hasError('min')">
              <mat-card-content>
                <p *ngIf="entriesControl.at(i)?.get('treatment')?.hasError('max')">
                  {{entriesControl.at(i)?.get('treatment')?.value > 0 ?
                  'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% higher than last year figure. Click to mark as correct'
                  : 'Negative cost indicated, if this was in fact a revenue click "Allow" to continue otherwise please correct the data'}}
                </p>
                <p *ngIf="entriesControl.at(i)?.get('treatment')?.hasError('min')">
                  {{entriesControl.at(i)?.get('treatment')?.value > 0 ?
                  'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% lower than last year figure. Click to mark as correct'
                  :'Negative cost indicated, if this was in fact a revenue click "Allow" to continue otherwise please correct the data'}}
                </p>
              </mat-card-content>
              <mat-card-actions align="end">
                <button mat-raised-button type="button" (click)="treatmentPopover._emitCloseEvent()">Close</button>
                <button mat-raised-button type="button" color="primary" (click)="allowValidation('treatment', i)">Allow</button>
              </mat-card-actions>
            </mat-card>
          </mde-popover>
        </mat-form-field>
      </td>
      <td mat-footer-cell *matFooterCellDef>
        <mat-form-field appearance="outline" class="filter-item">
          <input class="input-number" matInput type="number" [readonly]="true" [value]="totalValues[2].toFixed(2)"/>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="total">
      <th mat-header-cell *matHeaderCellDef>
        <div class="info">
          Total
          <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Cost.Operations.Total'"></app-help-icon-button>
        </div>
      </th>
      <td mat-cell *matCellDef="let category; let i = dataIndex" [formGroupName]="i">
        <mat-form-field appearance="outline" class="filter-item">
          <input class="input-number" matInput type="number" formControlName="totalOperations"
                 [readonly]="true"
                 (change)="sum()"/>
        </mat-form-field>
      </td>
      <td mat-footer-cell *matFooterCellDef>
        <mat-form-field appearance="outline" class="filter-item">
          <input class="input-number" matInput type="number" [readonly]="true" [value]="totalValues[3].toFixed(2)"/>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="operationsRemark">
      <th mat-header-cell *matHeaderCellDef>
        <div class="info">
          Remark
          <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Cost.Operations.Remark'"></app-help-icon-button>
        </div>
      </th>
      <td mat-cell *matCellDef="let category; let i = dataIndex" [formGroupName]="i">
        <mat-form-field appearance="outline" class="filter-item">
          <input matInput type="text" formControlName="operationsRemark"
                 [readonly]="kfRegistrationDetail?.kfRegistration?.completionStatus"/>
        </mat-form-field>
      </td>
      <td mat-footer-cell *matFooterCellDef>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let category; let i = dataIndex" [attr.colspan]="displayedColumnsOperations.length">
        <div class="example-element-detail-operations" [@detailExpand]="category == expandedElement ? 'expanded' : 'collapsed'" *ngIf="equivalenceControl.value !== 0 && equivalenceControl.value !== null">
          <div class="example-detail">
            <p class="entity">Total (€ / Euro)</p>
            <p class="collection">{{(entriesControl.controls[i].get('collection')?.value * this.equivalenceControl.value).toFixed(2)}}</p>
            <p class="logistics">{{(entriesControl.controls[i].get('logistics')?.value * this.equivalenceControl.value).toFixed(2)}}</p>
            <p class="treatment">{{(entriesControl.controls[i].get('treatment')?.value * this.equivalenceControl.value).toFixed(2)}}</p>
            <p class="total">{{(entriesControl.controls[i].get('totalOperations')?.value * this.equivalenceControl.value).toFixed(2)}}</p>
          </div>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsOperations"></tr>
    <tr mat-row *matRowDef="let category; columns: displayedColumnsOperations;"
        class="example-element-row"
        [class.example-expanded-row]="expandedElement === category"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumnsOperations; sticky: true"></tr>
  </table>
  <div class="info">
    <h1>Overhead</h1>
    <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Cost.Overhead'"></app-help-icon-button>
  </div>
  <table class="kf-registration-table-cost-overhead" mat-table [dataSource]="categories" formArrayName="entries" [multiTemplateDataRows]="true">

    <ng-container matColumnDef="entry">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let category; let i = dataIndex">
        <div class="entity-elements">
          <div>
            <mat-icon [class]="currencyControl.value === 'Euro' || (currencyControl.value !== 'Euro' && (equivalenceControl.value === 0 || equivalenceControl.value === null)) ? 'visibility-hidden' : ''"
                      (click)="expandedElement = expandedElement === category ? null : category; changeIcon(i, icon);">{{icon[i]?.icon}}
            </mat-icon>
            <p>{{category.description}}</p>
          </div>
          <span>Total</span>
        </div>
      </td>
      <td mat-footer-cell *matFooterCellDef> Total Overhead </td>
    </ng-container>

    <ng-container matColumnDef="clearing-house">
      <th mat-header-cell *matHeaderCellDef>
        <div class="info">
          Clearing House
          <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Cost.Operations.ClearingHouse'"></app-help-icon-button>
        </div>
      </th>
      <td mat-cell *matCellDef="let category; let i = dataIndex" [formGroupName]="i">
        <mat-form-field appearance="outline" class="filter-item">
          <input onfocus="this.select()" class="input-number" matInput type="number" formControlName="clearingHouse"
                 [readonly]="kfRegistrationDetail?.kfRegistration?.completionStatus"
                 (change)="sum()"
                 [mdePopoverTriggerFor]="clearingHousePopover"
                 mdePopoverTriggerOn="none"
                 mdePopoverArrowColor="none"
                 (focusin)="entriesControl.at(i).get('clearingHouse')?.invalid ? popoverTrigger.openPopover() : null"
                 #popoverTrigger="mdePopoverTrigger"
          />
          <mde-popover #clearingHousePopover="mdePopover" [mdePopoverOverlapTrigger]="false">
            <mat-card *ngIf="entriesControl.at(i)?.get('clearingHouse')?.hasError('max') || entriesControl.at(i)?.get('clearingHouse')?.hasError('min')">
              <mat-card-content>
                <p *ngIf="entriesControl.at(i)?.get('clearingHouse')?.hasError('max')">
                  {{entriesControl.at(i)?.get('clearingHouse')?.value > 0 ?
                  'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% higher than last year figure. Click to mark as correct'
                  : 'Negative cost indicated, if this was in fact a revenue click "Allow" to continue otherwise please correct the data'}}
                </p>
                <p *ngIf="entriesControl.at(i)?.get('clearingHouse')?.hasError('min')">
                  {{entriesControl.at(i)?.get('clearingHouse')?.value > 0 ?
                  'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% lower than last year figure. Click to mark as correct'
                  :'Negative cost indicated, if this was in fact a revenue click "Allow" to continue otherwise please correct the data'}}
                </p>
              </mat-card-content>
              <mat-card-actions align="end">
                <button mat-raised-button type="button" (click)="clearingHousePopover._emitCloseEvent()">Close</button>
                <button mat-raised-button type="button" color="primary" (click)="allowValidation('clearingHouse', i)">Allow</button>
              </mat-card-actions>
            </mat-card>
          </mde-popover>
        </mat-form-field>
      </td>
      <td mat-footer-cell *matFooterCellDef>
        <mat-form-field appearance="outline" class="filter-item">
          <input class="input-number" matInput type="number" [readonly]="true" [value]="totalValues[4].toFixed(2)"/>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="communication">
      <th mat-header-cell *matHeaderCellDef>
        <div class="info">
          Communication
          <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Cost.Operations.Communication'"></app-help-icon-button>
        </div>
      </th>
      <td mat-cell *matCellDef="let category; let i = dataIndex" [formGroupName]="i">
        <mat-form-field appearance="outline" class="filter-item">
          <input onfocus="this.select()" class="input-number" matInput type="number" formControlName="communication"
                 [readonly]="kfRegistrationDetail?.kfRegistration?.completionStatus"
                 (change)="sum()"
                 [mdePopoverTriggerFor]="communicationPopover"
                 mdePopoverTriggerOn="none"
                 mdePopoverArrowColor="none"
                 (focusin)="entriesControl.at(i).get('communication')?.invalid ? popoverTrigger.openPopover() : null"
                 #popoverTrigger="mdePopoverTrigger"
          />
          <mde-popover #communicationPopover="mdePopover" [mdePopoverOverlapTrigger]="false">
            <mat-card *ngIf="entriesControl.at(i)?.get('communication')?.hasError('max') || entriesControl.at(i)?.get('communication')?.hasError('min')">
              <mat-card-content>
                <p *ngIf="entriesControl.at(i)?.get('communication')?.hasError('max')">
                  {{entriesControl.at(i)?.get('communication')?.value > 0 ?
                  'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% higher than last year figure. Click to mark as correct'
                  : 'Negative cost indicated, if this was in fact a revenue click "Allow" to continue otherwise please correct the data'}}
                </p>
                <p *ngIf="entriesControl.at(i)?.get('communication')?.hasError('min')">
                  {{entriesControl.at(i)?.get('communication')?.value > 0 ?
                  'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% lower than last year figure. Click to mark as correct'
                  :'Negative cost indicated, if this was in fact a revenue click "Allow" to continue otherwise please correct the data'}}
                </p>
              </mat-card-content>
              <mat-card-actions align="end">
                <button mat-raised-button type="button" (click)="communicationPopover._emitCloseEvent()">Close</button>
                <button mat-raised-button type="button" color="primary" (click)="allowValidation('communication', i)">Allow</button>
              </mat-card-actions>
            </mat-card>
          </mde-popover>
        </mat-form-field>
      </td>
      <td mat-footer-cell *matFooterCellDef>
        <mat-form-field appearance="outline" class="filter-item">
          <input class="input-number" matInput type="number" [readonly]="true" [value]="totalValues[5].toFixed(2)"/>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="rd">
      <th mat-header-cell *matHeaderCellDef>
        <div class="info">
          R&D
          <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Cost.Operations.RD'"></app-help-icon-button>
        </div>
      </th>
      <td mat-cell *matCellDef="let category; let i = dataIndex" [formGroupName]="i">
        <mat-form-field appearance="outline" class="filter-item">
          <input onfocus="this.select()" class="input-number" matInput type="number" formControlName="rd"
                 [readonly]="kfRegistrationDetail?.kfRegistration?.completionStatus"
                 (change)="sum()"
                 [mdePopoverTriggerFor]="officePopover"
                 mdePopoverTriggerOn="none"
                 mdePopoverArrowColor="none"
                 (focusin)="entriesControl.at(i).get('rd')?.invalid ? popoverTrigger.openPopover() : null"
                 #popoverTrigger="mdePopoverTrigger"
          />
          <mde-popover #officePopover="mdePopover" [mdePopoverOverlapTrigger]="false">
            <mat-card *ngIf="entriesControl.at(i)?.get('rd')?.hasError('max') || entriesControl.at(i)?.get('rd')?.hasError('min')">
              <mat-card-content>
                <p *ngIf="entriesControl.at(i)?.get('rd')?.hasError('max')">
                  {{entriesControl.at(i)?.get('rd')?.value > 0 ?
                  'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% higher than last year figure. Click to mark as correct'
                  : 'Negative cost indicated, if this was in fact a revenue click "Allow" to continue otherwise please correct the data'}}
                </p>
                <p *ngIf="entriesControl.at(i)?.get('rd')?.hasError('min')">
                  {{entriesControl.at(i)?.get('rd')?.value > 0 ?
                  'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% lower than last year figure. Click to mark as correct'
                  :'Negative cost indicated, if this was in fact a revenue click "Allow" to continue otherwise please correct the data'}}
                </p>
              </mat-card-content>
              <mat-card-actions align="end">
                <button mat-raised-button type="button" (click)="officePopover._emitCloseEvent()">Close</button>
                <button mat-raised-button type="button" color="primary" (click)="allowValidation('rd', i)">Allow</button>
              </mat-card-actions>
            </mat-card>
          </mde-popover>
        </mat-form-field>
      </td>
      <td mat-footer-cell *matFooterCellDef>
        <mat-form-field appearance="outline" class="filter-item">
          <input class="input-number" matInput type="number" [readonly]="true" [value]="totalValues[6].toFixed(2)"/>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="office">
      <th mat-header-cell *matHeaderCellDef>
        <div class="info">
          Office
          <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Cost.Operations.Office'"></app-help-icon-button>
        </div>
      </th>
      <td mat-cell *matCellDef="let category; let i = dataIndex" [formGroupName]="i">
        <mat-form-field appearance="outline" class="filter-item">
          <input onfocus="this.select()" class="input-number" matInput type="number" formControlName="office"
                 [readonly]="kfRegistrationDetail?.kfRegistration?.completionStatus"
                 (change)="sum()"
                 [mdePopoverTriggerFor]="officePopover"
                 mdePopoverTriggerOn="none"
                 mdePopoverArrowColor="none"
                 (focusin)="entriesControl.at(i).get('office')?.invalid ? popoverTrigger.openPopover() : null"
                 #popoverTrigger="mdePopoverTrigger"
          />
          <mde-popover #officePopover="mdePopover" [mdePopoverOverlapTrigger]="false">
            <mat-card *ngIf="entriesControl.at(i)?.get('office')?.hasError('max') || entriesControl.at(i)?.get('office')?.hasError('min')">
              <mat-card-content>
                <p *ngIf="entriesControl.at(i)?.get('office')?.hasError('max')">
                  {{entriesControl.at(i)?.get('office')?.value > 0 ?
                  'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% higher than last year figure. Click to mark as correct'
                  : 'Negative cost indicated, if this was in fact a revenue click "Allow" to continue otherwise please correct the data'}}
                </p>
                <p *ngIf="entriesControl.at(i)?.get('office')?.hasError('min')">
                  {{entriesControl.at(i)?.get('office')?.value > 0 ?
                  'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% lower than last year figure. Click to mark as correct'
                  :'Negative cost indicated, if this was in fact a revenue click "Allow" to continue otherwise please correct the data'}}
                </p>
              </mat-card-content>
              <mat-card-actions align="end">
                <button mat-raised-button type="button" (click)="officePopover._emitCloseEvent()">Close</button>
                <button mat-raised-button type="button" color="primary" (click)="allowValidation('office', i)">Allow</button>
              </mat-card-actions>
            </mat-card>
          </mde-popover>
        </mat-form-field>
      </td>
      <td mat-footer-cell *matFooterCellDef>
        <mat-form-field appearance="outline" class="filter-item">
          <input class="input-number" matInput type="number" [readonly]="true" [value]="totalValues[7].toFixed(2)"/>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="other">
      <th mat-header-cell *matHeaderCellDef>
        <div class="info">
          Other
          <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Cost.Operations.Other'"></app-help-icon-button>
        </div>
      </th>
      <td mat-cell *matCellDef="let category; let i = dataIndex" [formGroupName]="i">
        <mat-form-field appearance="outline" class="filter-item">
          <input onfocus="this.select()" class="input-number" matInput type="number" formControlName="other"
                 [readonly]="kfRegistrationDetail?.kfRegistration?.completionStatus"
                 (change)="sum()"
                 [mdePopoverTriggerFor]="otherPopover"
                 mdePopoverTriggerOn="none"
                 mdePopoverArrowColor="none"
                 (focusin)="entriesControl.at(i).get('other')?.invalid ? popoverTrigger.openPopover() : null"
                 #popoverTrigger="mdePopoverTrigger"
          />
          <mde-popover #otherPopover="mdePopover" [mdePopoverOverlapTrigger]="false">
            <mat-card *ngIf="entriesControl.at(i)?.get('other')?.hasError('max') || entriesControl.at(i)?.get('other')?.hasError('min')">
              <mat-card-content>
                <p *ngIf="entriesControl.at(i)?.get('other')?.hasError('max')">
                  {{entriesControl.at(i)?.get('other')?.value > 0 ?
                  'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% higher than last year figure. Click to mark as correct'
                  : 'Negative cost indicated, if this was in fact a revenue click "Allow" to continue otherwise please correct the data'}}
                </p>
                <p *ngIf="entriesControl.at(i)?.get('other')?.hasError('min')">
                  {{entriesControl.at(i)?.get('other')?.value > 0 ?
                  'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% lower than last year figure. Click to mark as correct'
                  :'Negative cost indicated, if this was in fact a revenue click "Allow" to continue otherwise please correct the data'}}
                </p>
              </mat-card-content>
              <mat-card-actions align="end">
                <button mat-raised-button type="button" (click)="otherPopover._emitCloseEvent()">Close</button>
                <button mat-raised-button type="button" color="primary" (click)="allowValidation('other', i)">Allow</button>
              </mat-card-actions>
            </mat-card>
          </mde-popover>
        </mat-form-field>
      </td>
      <td mat-footer-cell *matFooterCellDef>
        <mat-form-field appearance="outline" class="filter-item">
          <input class="input-number" matInput type="number" [readonly]="true" [value]="totalValues[8].toFixed(2)"/>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="total">
      <th mat-header-cell *matHeaderCellDef>
        <div class="info">
          Total
          <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Cost.Operations.Total'"></app-help-icon-button>
        </div>
      </th>
      <td mat-cell *matCellDef="let category; let i = dataIndex" [formGroupName]="i">
        <mat-form-field appearance="outline" class="filter-item">
          <input class="input-number" matInput type="number" formControlName="totalOverhead"
                 [readonly]="true"
                 (change)="sum()"/>
        </mat-form-field>
      </td>
      <td mat-footer-cell *matFooterCellDef>
        <mat-form-field appearance="outline" class="filter-item">
          <input class="input-number" matInput type="number" [readonly]="true" [value]="totalValues[9].toFixed(2)"/>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="overheadRemark">
      <th mat-header-cell *matHeaderCellDef>
        <div class="info">
          Remark
          <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Cost.Operations.Remark'"></app-help-icon-button>
        </div>
      </th>
      <td mat-cell *matCellDef="let category; let i = dataIndex" [formGroupName]="i">
        <mat-form-field appearance="outline" class="filter-item">
          <input matInput type="text" formControlName="overheadRemark"
                 [readonly]="kfRegistrationDetail?.kfRegistration?.completionStatus"/>
        </mat-form-field>
      </td>
      <td mat-footer-cell *matFooterCellDef>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let category; let i = dataIndex" [attr.colspan]="displayedColumnsOverhead.length">
        <div class="example-element-detail-overhead" [@detailExpand]="category == expandedElement ? 'expanded' : 'collapsed'" *ngIf="equivalenceControl.value !== 0 && equivalenceControl.value !== null">
          <div class="example-detail">
            <p class="entity">Total (€ / Euro)</p>
            <p class="clearingHouse">{{(entriesControl.controls[i].get('clearingHouse')?.value * this.equivalenceControl.value).toFixed(2)}}</p>
            <p class="communication">{{(entriesControl.controls[i].get('communication')?.value * this.equivalenceControl.value).toFixed(2)}}</p>
            <p class="rd">{{(entriesControl.controls[i].get('rd')?.value * this.equivalenceControl.value).toFixed(2)}}</p>
            <p class="office">{{(entriesControl.controls[i].get('office')?.value * this.equivalenceControl.value).toFixed(2)}}</p>
            <p class="other">{{(entriesControl.controls[i].get('other')?.value * this.equivalenceControl.value).toFixed(2)}}</p>
            <p class="total">{{(entriesControl.controls[i].get('totalOverhead')?.value * this.equivalenceControl.value).toFixed(2)}}</p>
          </div>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsOverhead"></tr>
    <tr mat-row *matRowDef="let category; columns: displayedColumnsOverhead;"
        class="example-element-row"
        [class.example-expanded-row]="expandedElement === category"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumnsOverhead; sticky: true"></tr>
  </table>

  <form class="form-search-bar" [formGroup]="additionalForm" autocomplete="off">
    <div class="info">
      <h1>Payments to collection points</h1>
      <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Cost.Payments'"></app-help-icon-button>
    </div>
    <table class="kf-registration-table-additional" mat-table [dataSource]="additionalDataSource" formArrayName="entries" [multiTemplateDataRows]="true">
      <ng-container matColumnDef="entry">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let additional; let i = dataIndex" >
          <div class="entity-elements">
            <div>
              <mat-icon [class]="currencyControl.value === 'Euro' || (currencyControl.value !== 'Euro' && (equivalenceControl.value === 0 || equivalenceControl.value === null)) ? 'visibility-hidden' : ''"
                        (click)="expandedAdditionalElement = expandedAdditionalElement === additional ? null : additional; changeIcon(i, additionalIcon);">{{additionalIcon[i]?.icon}}
              </mat-icon>
              <p>{{additional.entry}}</p>
              <!--              <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Cost.Operations.' + additional.info"></app-help-icon-button>-->
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="paymentRetail">
        <th mat-header-cell *matHeaderCellDef>
          <div class="info">
            Payment to retail (€/ton)
            <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Cost.Operations.AdditionalRemark'" style="visibility: hidden"></app-help-icon-button>
          </div>
        </th>
        <td mat-cell *matCellDef="let category; let i = dataIndex" [formGroupName]="i">
          <mat-form-field appearance="outline" class="filter-item">
            <input class="input-number" matInput type="number" formControlName="paymentRetail"/>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="paymentPoint">
        <th mat-header-cell *matHeaderCellDef>
          <div class="info">
            Payment to Municipal point (€/ton)
            <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Cost.Operations.AdditionalRemark'" style="visibility: hidden"></app-help-icon-button>
          </div>
        </th>
        <td mat-cell *matCellDef="let category; let i = dataIndex" [formGroupName]="i">
          <mat-form-field appearance="outline" class="filter-item">
            <input class="input-number" matInput type="number" formControlName="paymentPoint"/>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="paymentOther">
        <th mat-header-cell *matHeaderCellDef>
          <div class="info">
            Payment to other collectors (€/ton)
            <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Cost.Operations.AdditionalRemark'" style="visibility: hidden"></app-help-icon-button>
          </div>
        </th>
        <td mat-cell *matCellDef="let category; let i = dataIndex" [formGroupName]="i">
          <mat-form-field appearance="outline" class="filter-item">
            <input class="input-number" matInput type="number" formControlName="paymentOther"/>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="remark">
        <th mat-header-cell *matHeaderCellDef>
          <div class="info">
            Remarks
            <app-help-icon-button [code]="'keyfigureentry.WeeeSystem.Cost.Operations.AdditionalRemark'"></app-help-icon-button>
          </div>
        </th>
        <td mat-cell *matCellDef="let category; let i = dataIndex" [formGroupName]="i">
          <mat-form-field appearance="outline" class="filter-item">
            <input matInput type="text" formControlName="remarks" />
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let category; let i = dataIndex" [attr.colspan]="additionalDisplayedColumns.length">
          <div class="example-element-detail-additional" [@detailExpand]="category == expandedAdditionalElement ? 'expanded' : 'collapsed'" *ngIf="equivalenceControl.value !== 0 && equivalenceControl.value !== null">
            <div class="example-detail">
              <p class="entity">(€ / Euro)</p>
              <p class="payment">{{(additionalControl.controls[i].get('payment')?.value * this.equivalenceControl.value).toFixed(2)}}</p>
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="additionalDisplayedColumns"></tr>
      <tr mat-row *matRowDef="let category; columns: additionalDisplayedColumns;"
          class="example-element-row"
          [class.example-expanded-row]="expandedAdditionalElement === category"></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
    </table>

  </form>

  <p class="mat-error" *ngIf="entriesForm.invalid">
    Please correct or confirm values that are negative or different from those of the previous year - highlighted in red in the form. (Please click on cells containing values or click on Save to discover the error).
  </p>
  <div class="wizard-buttons-container align-right">
    <button mat-raised-button color="primary" type="button" #markAsCompletedButton
            (click)="!markAsCompletedButton.disabled ? markAsCompleted() : ''"
            *ngIf="!simpleUser"
            [disabled]="kfRegistrationDetail?.kfRegistration?.completionStatus || entriesForm.invalid">
      <mat-icon class="material-icons-outlined">check_circle</mat-icon>
      <span> Mark as completed</span>
    </button>
    <button mat-raised-button class="reset" type="button"
            (click)="reset()"
            *ngIf="!simpleUser"
            [disabled]="kfRegistrationDetail?.kfRegistration?.completionStatus || kfRegistrationDetail === undefined">
      <span>Reset </span>
      <mat-icon class="material-icons-outlined">refresh</mat-icon>
    </button>
    <button mat-raised-button matStepperPrevious type="button">
      <mat-icon class="material-icons-outlined">chevron_left</mat-icon>
      <span>Back</span>
    </button>
    <button mat-raised-button type="submit" color="primary"
            *ngIf="!kfRegistrationDetail?.kfRegistration?.completionStatus && !simpleUser"
            [disabled]="(currencyControl.value !== 'Euro' ? currencyForm.invalid : false)">
      <span>Save</span>
      <mat-icon class="material-icons-outlined">chevron_right</mat-icon>
    </button>
    <button mat-raised-button type="button" color="primary"
            (click)="this.redirectUrlEmitter.emit()"
            *ngIf="kfRegistrationDetail?.kfRegistration?.completionStatus">
      <mat-icon class="material-icons-outlined">undo</mat-icon>
      <span>Return</span>
    </button>
  </div>
</form>

